import { computed } from "vue";
import { useStore } from "@nuxtjs/composition-api";

export default {
  __name: 'index',
  props: {
  visible: {
    type: Boolean,
    required: false,
    default: false,
  },
  variant: {
    type: String,
    required: false,
    validator: function (value) {
      return (
        [
          "create",
          "edit",
          "duplicate",
          "delete",
          "add-item",
          "remove-item",
        ].indexOf(value) !== -1
      );
    },
    default: "create",
  },
  initialName: {
    type: String,
    required: false,
    default: "",
  },
  listId: {
    type: [String, Number],
    required: false,
  },
  sku: {
    type: String,
    required: false,
    default: "",
  },
},
  emits: ["hide"],
  setup(__props, { emit }) {

const props = __props;



const store = useStore();

const title = computed(() => {
  let t = "";
  switch (props.variant) {
    case "create":
      t = store.state.labels.create_new_favourites_list;
      break;

    case "edit":
      t = store.state.labels.edit_list_name;
      break;

    case "duplicate":
      t = store.state.labels.create_list_copy;
      break;

    case "delete":
      t = store.state.labels.permanently_delete_list;
      break;

    case "add-item":
      t = store.state.labels.add_product_to_list;
      break;

    case "remove-item":
      t = store.state.labels.permanently_delete_from_list;
      break;
  }

  return t;
});

function handleSuccess() {
  emit("hide");
}

return { __sfc: true,props, store, emit, title, handleSuccess }
}

}